<template>
  <div
    class="sb-tab-panel"
    role="tabpanel"
    :tabindex="isActive ? 0 : -1"
    :aria-hidden="!isActive"
  >
    <template v-if="isActive">
      <slot />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed, inject } from 'vue'
import type { HTMLAttributes } from 'vue'
import { SbTabPanelContext } from './types'

export type SbTabPanelProps = {
  name: string | number
  // eslint-disable-next-line vue/prop-name-casing
} & /* @vue-ignore */ Pick<HTMLAttributes, 'aria-labelledby'>

const props = defineProps<SbTabPanelProps>()

const activeTab = inject<() => string | number>(SbTabPanelContext, () => '')

const isActive = computed(() => activeTab() === props.name)
</script>
